import React, { useRef, useState } from 'react';
import { useQueryClient } from 'react-query';
import { LoadingButton } from '@mui/lab';
import MentorForm from './MentorForm';
import { Box, Typography, Stack, Button } from '@mui/material';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { API_URL } from '../../../../links/API_LINKS';
import axios from 'axios';

const EditMentor = ({ mentorToEdit, setMentorToEdit }) => {
  const [serverResponse, setServerResponse] = useState();
  const formikRef = useRef();
  const queryClient = useQueryClient();

  const {
    _id,
    name,
    country,
    website,
    designation,
    linkedIn,
    imageUrl,
    mentorSign,
    sectionTitle,
    sectionContent,
  } = {
    ...mentorToEdit,
  };
  console.log(mentorToEdit);
  return (
    <div>
      <Typography my={4}>
        <Button onClick={() => setMentorToEdit(null)}>Back</Button>
      </Typography>
      <Formik
        enableReinitialize={false}
        innerRef={formikRef}
        initialValues={{
          mentorId: _id,
          name: name,
          designation: designation,
          country: country,
          imageUrl: imageUrl,
          mentorSign: mentorSign,
          website: website,
          linkedIn: linkedIn,
          sectionTitle: sectionTitle,
          sectionContent: sectionContent,
        }}
        validationSchema={Yup.object({
          name: Yup.string()
            .min(3, 'Must be 3 characters or more')
            .max(30, 'Must be 30 characters or less')
            .required('Please enter a name'),
          designation: Yup.string().required('Please enter the designation'),
          imageUrl: Yup.string().url().required(),
          mentorSign: Yup.string().url().required(),
          sectionContent: Yup.array().of(
            Yup.object().shape({
              contentToPublish: Yup.string().required(
                'Mentor Brief content is required'
              ),
            })
          ),
        })}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setServerResponse('');
          axios({
            method: 'PUT',
            url: API_URL + '/mentor',
            data: values,
          })
            .then(function (response) {
              console.log(response);
              queryClient.invalidateQueries('fetchMentor');
              setServerResponse(response.data.msg);
              setSubmitting(false);
              setMentorToEdit(null);
            })
            .catch(function (response) {
              console.log(response);
              setServerResponse('Error! Could not process your request.');
              setSubmitting(false);
            });
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => (
          <Form>
            <MentorForm values={values} setFieldValue={setFieldValue} />

            <Stack
              direction='row'
              justifyContent='center'
              alignItems='center'
              spacing={3}
            >
              <LoadingButton
                type='submit'
                variant='contained'
                loading={isSubmitting}
              >
                Update
              </LoadingButton>
            </Stack>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                p: 1,
                m: 1,
              }}
            >
              {serverResponse && <Typography>{serverResponse}</Typography>}
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EditMentor;
